/* loaded by smart-asset */
export default require("./close_light-24px~KEPtAkNe.svg")